import { mapActions } from "vuex";

// Helper pour toutes les pages des formulaires.
// Expose `saveAndContinueLater`, `saveAndContinue`, `redirect`
export default {
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      redirectValue: "",
    };
  },
  methods: {
    ...mapActions({
      envoiLien: "DemandeAdmission/envoiLien",
    }),
    save() {
      throw "Non implémenté";
    },
    saveAndContinueLater() {
      this.redirectValue = "later";

      if (this.readonly) {
        return this.redirect();
      }

      this.messageSelector = "Creation";
      this.overlay = true;
      this.envoiLien().then(() => {
        this.save();
      });
    },
    saveAndContinue() {
      this.redirectValue = "continue";

      if (this.readonly) {
        return this.redirect();
      }

      this.save();
    },
    redirect() {
      if (this.redirectValue === "later") {
        this.$router.push({ name: "TerminerPlusTard" });
      } else if (this.redirectValue === "continue") {
        this.next();
      }
    },
  },
};